import { TmrBaseResource } from 'stylewhere/api'

export class TransferToZone extends TmrBaseResource {
  static endpoint = 'tracking/api/v1/operations/transfersToZone'

  static batchValidateEndpoint() {
    return `${this.endpoint}/batchValidate`
  }
}
